import keyMirror from 'keymirror';

const POD_CODES = keyMirror({
  poflbk: null,
  lyltbk: null,
  chkibk: null,
  mtpsbk: null,
  slfcmbk: null,
});

export default POD_CODES;